import { render, staticRenderFns } from "./imageAnalystResultList.vue?vue&type=template&id=b8147736&scoped=true&"
import script from "./imageAnalystResultList.vue?vue&type=script&lang=js&"
export * from "./imageAnalystResultList.vue?vue&type=script&lang=js&"
import style0 from "./imageAnalystResultList.vue?vue&type=style&index=0&id=b8147736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8147736",
  null
  
)

export default component.exports